import { useTranslation } from "react-i18next";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, TrendingUpIcon, UsersIcon } from 'lucide-react';
export function CustomMetrics() {
  const {
    t
  } = useTranslation("analytics");
  const navigate = useNavigate();
  return <div className="max-w-5xl mx-auto" data-id="element-2309">
      {/* Hero Section with Preview Card */}
      <div className="mb-12" data-id="element-2310">
        <div className="relative" data-id="element-2311">
          {/* Gradient Background Card */}
          <div className="bg-gradient-to-br from-blue-400 via-cyan-400 to-teal-400 rounded-2xl p-8 shadow-xl" data-id="element-2312">
            {/* Preview Dashboard Card */}
            <div className="bg-white rounded-xl shadow-lg p-6 max-w-md" data-id="element-2313">
              <div className="flex items-center justify-between mb-4" data-id="element-2314">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-2315">
                  {t("pages.CustomMetrics.check_daily")}
                </h3>
                <button className="text-sm text-gray-600 hover:text-gray-900" data-id="element-2316">
                  {t("pages.CustomMetrics.see_all")}
                </button>
              </div>
              <p className="text-xs text-gray-500 mb-6" data-id="element-2317">{t("pages.CustomMetrics.shared")}</p>

              {/* Metric Cards */}
              <div className="space-y-4" data-id="element-2318">
                {/* Trial conversion rate */}
                <div className="flex items-center justify-between" data-id="element-2319">
                  <div data-id="element-2320">
                    <p className="text-xs text-gray-600 mb-1" data-id="element-2321">
                      {t("pages.CustomMetrics.trial_conversion_rate")}
                    </p>
                    <div className="flex items-baseline gap-2" data-id="element-2322">
                      <span className="text-2xl font-bold text-gray-900" data-id="element-2323">
                        56.8%
                      </span>
                      <span className="text-xs text-green-600" data-id="element-2324">+3.1%</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-2325">
                    {/* Mini chart */}
                    <svg width="60" height="30" className="text-blue-500" data-id="element-2326">
                      <polyline points="0,25 10,20 20,22 30,15 40,18 50,10 60,8" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-2327" />
                      
                    </svg>
                    <div className="text-right" data-id="element-2328">
                      <p className="text-xs text-gray-600" data-id="element-2329">{t("pages.CustomMetrics.high")}</p>
                      <p className="text-lg font-semibold text-gray-900" data-id="element-2330">598</p>
                      <p className="text-xs text-green-600" data-id="element-2331">+12</p>
                    </div>
                  </div>
                </div>

                {/* New customers */}
                <div className="flex items-center justify-between" data-id="element-2332">
                  <div data-id="element-2333">
                    <p className="text-xs text-gray-600 mb-1" data-id="element-2334">{t("pages.CustomMetrics.new_customers")}</p>
                    <div className="flex items-baseline gap-2" data-id="element-2335">
                      <span className="text-2xl font-bold text-gray-900" data-id="element-2336">
                        1,624
                      </span>
                      <span className="text-xs text-green-600" data-id="element-2337">+4.5%</span>
                    </div>
                  </div>
                  <div className="flex gap-0.5" data-id="element-2338">
                    {/* Mini bar chart */}
                    {[12, 18, 15, 22, 19, 25, 20, 28, 24, 30, 26, 32].map((height, i) => <div key={i} className="w-1.5 bg-purple-500 rounded-sm" style={{
                    height: `${height}px`
                  }} data-id="element-2339" />)}
                  </div>
                </div>
              </div>
            </div>

            {/* Create new group popup */}
            <div className="absolute top-4 right-4 bg-white rounded-lg shadow-xl p-4 w-64" data-id="element-2340">
              <h4 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-2341">
                {t("pages.CustomMetrics.create_a_new_group")}
              </h4>
              <div className="mb-3" data-id="element-2342">
                <label className="text-xs text-gray-600 mb-1 block" data-id="element-2343">{t("pages.CustomMetrics.name")}</label>
                <input type="text" value="Growth reports" readOnly className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-gray-50" data-id="element-2344" />
                
              </div>
              <button className="w-full flex items-center justify-center gap-2 px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-2345">
                <PlusIcon size={16} data-id="element-2346" />
                {t("pages.CustomMetrics.add_reports")}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="text-center mb-8" data-id="element-2347">
        <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-2348">
          {t("pages.CustomMetrics.monitor_your_data_with_custom_metrics")}
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-2349">
          {t("pages.CustomMetrics.create_custom_metrics_with_nadi_to")}
        </p>
      </div>

      {/* CTA Button */}
      <div className="text-center" data-id="element-2350">
        <button onClick={() => navigate('/nadi')} className="inline-flex items-center px-6 py-3 text-base font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-sm transition-colors" data-id="element-2351">
          
          {t("pages.CustomMetrics.go_to_nadi")}
        </button>
      </div>

      {/* Feature Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16" data-id="element-2352">
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2353">
          <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4" data-id="element-2354">
            <TrendingUpIcon size={24} className="text-blue-600" data-id="element-2355" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-2356">
            {t("pages.CustomMetrics.track_key_metrics")}
          </h3>
          <p className="text-sm text-gray-600" data-id="element-2357">
            {t("pages.CustomMetrics.monitor_your_most_important_business_metrics")}
          </p>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2358">
          <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4" data-id="element-2359">
            <UsersIcon size={24} className="text-purple-600" data-id="element-2360" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-2361">
            {t("pages.CustomMetrics.share_insights")}
          </h3>
          <p className="text-sm text-gray-600" data-id="element-2362">
            {t("pages.CustomMetrics.collaborate_with_your_team_by_sharing")}
          </p>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2363">
          <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4" data-id="element-2364">
            <PlusIcon size={24} className="text-green-600" data-id="element-2365" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-2366">
            {t("pages.CustomMetrics.easy_to_create")}
          </h3>
          <p className="text-sm text-gray-600" data-id="element-2367">
            {t("pages.CustomMetrics.build_custom_metrics_with_an_intuitive")}
          </p>
        </div>
      </div>
    </div>;
}